export class GetSeoContentRequest {
  constructor() {
    this.provinceId = null
    this.districtId = null
  }
  provinceId: number | null
  districtId: number | null

}
export class GetFaqsRequest {
  constructor() {
    this.PageNumber = null
    this.PageSize = null
    this.Search = null
    this.IsShow = null
   
  }
  PageNumber: number | null
  PageSize: number | null
  Search: string | null
  IsShow: boolean | null

}
export class GetProductDevelopersRequest {
  constructor() {
    this.PageNumber = null
    this.PageSize = null
    this.Search = null
    this.ShowInMainPage = null

  }
  PageNumber: number | null
  PageSize: number | null
  Search: string | null
  ShowInMainPage: boolean | null

}

export class GetSeoContentResponse {
  constructor() {
    this.seoContentId = 0
    this.metaTag = ''
    this.metaDescription = ''
    this.description = ''
    this.province = ''
    this.district = ''
  }

  seoContentId: number
  metaTag: string
  metaDescription: string
  description: string
  province: string
  district: string
}

export enum FaqCategoryEnum {
  "Satın Alma Süreci" = 1,
  "Kira Geliri" = 2,
  "Sahip Olduğun Hisseler" = 3,
  "Satış Süreci" = 4
}
export class GetFaqsResponse {
  constructor() {
    this.id = 0
    this.category = 1
    this.title = ''
    this.description = ''
    this.orderBy = 0
    this.isShow = false
  }

  id: number
  category: FaqCategoryEnum
  title: string
  description: string
  orderBy: number
  isShow: boolean
}
export class GetProductDevelopersResponse {
  constructor() {
    this.id = 0
    this.developerName = ''
    this.fileUrl = ''
    this.originalFileName = ''
  }
  id: number
  developerName: string
  fileUrl: string
  originalFileName: string
}


export class GetContractsByCategoryQuery {
  constructor() {
    this.seoUrl = null

  }
  seoUrl: string | null


}
export class GetProductDevelopersAllQuery {
  constructor() {
    this.pageNumber = null
    this.pageSize = null
    this.search = null
    this.showInMainPage = null

  }
  pageNumber: number | null
  pageSize: number | null
  search: string | null
  showInMainPage: boolean | null
}